import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

/**
 * PostHog wrapper component that conditionally initializes analytics
 * Only loads and initializes PostHog in production environment
 */
export function PostHogWrapper({ children }) {
	// Skip PostHog entirely in development
	if (process.env.NODE_ENV !== 'production') {
		return children;
	}

	// Only initialize in production environment
	if (typeof window !== 'undefined') {
		posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
			api_host: process.env.REACT_APP_POSTHOG_HOST,
		});
	}

	return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
